var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _vm.getFormConfig
            ? _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.clearPLabel(_vm.getFormConfig.label)),
                  },
                }),
              ])
            : _vm._e(),
          _vm.getFormConfig && _vm.getFormConfig.notice
            ? _c("el-alert", {
                staticStyle: { "margin-bottom": "10px" },
                attrs: {
                  title: _vm.getFormConfig.notice.content,
                  "show-icon": "",
                  type: "warning",
                },
              })
            : _vm._e(),
          _c("avue-form", {
            ref: "refAttach",
            attrs: {
              option: _vm.optionAttach,
              "upload-error": _vm.uploadError,
            },
            model: {
              value: _vm.formAttach,
              callback: function ($$v) {
                _vm.formAttach = $$v
              },
              expression: "formAttach",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }